function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7fc7ff"
    },
    points: "409.6,238.933 409.6,0 102.4,0 102.4,238.933 25.6,238.933 25.6,512 102.4,512 409.6,512  486.4,512 486.4,238.933 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#62bbff"
    },
    points: "409.6,238.933 409.6,0 256,0 256,512 486.4,512 486.4,238.933 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "341.333,119.467 290.133,119.467 290.133,68.267 221.867,68.267 221.867,119.467  170.667,119.467 170.667,187.733 221.867,187.733 221.867,238.933 290.133,238.933 290.133,187.733 341.333,187.733 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "290.133,119.467 290.133,68.267 256,68.267 256,238.933 290.133,238.933 290.133,187.733  341.333,187.733 341.333,119.467 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 409.6,
    style: {
      fill: "#5A8BB0"
    },
    width: 256,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 409.6,
    style: {
      fill: "#3C5D76"
    },
    width: 128,
    height: 102.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332.8,
    y: 307.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 307.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.467,
    y: 307.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.067,
    y: 307.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 59.733,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.067,
    y: 409.6,
    style: {
      fill: "#FFFFFF"
    },
    width: 59.733,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.2,
    y: 409.6,
    style: {
      fill: "#FFFFFF"
    },
    width: 59.733,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.2,
    y: 307.2,
    style: {
      fill: "#FFFFFF"
    },
    width: 59.733,
    height: 51.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.fd851772949862cd32488bba2eefce95.svg";
export { ForwardRef as ReactComponent };